import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'
import { Font14 } from 'components/Typography'

export const StyledBackButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  transition: all 0.2s ease;
  background: ${theme.colors.white};
  @media ${theme.devices.tablet} {
    background: inherit;
    padding: 16px 24px;
  }
`

export const StyledMBackIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const StyledBackButtonText = styled.span`
  padding-left: 20px;
  white-space: nowrap;
  animation-name: ${theme.animations.fadeIn};
  animation-duration: 0.2s;
  display: none;
  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const StyledBackButton = styled(CommonLinkButton)`
  align-items: center;
  display: flex;
  ${Font14};
  font-weight: 900;
  line-height: 24px;
  color: ${theme.colors.horizonOrange};
  padding: 16px;
  :hover {
    opacity: 0.8;
  }
  @media ${theme.devices.tablet} {
    padding: 0;
  }
`
